<template>
  <div class="print">
    <!-- 1. 헤더 및 결재란 -->
    <section class="section-approval">
      <div class="header-left-area">
        <p class="print-title">{{ $t('종사자 의견 청취') }}</p>
        <div class="division-title mt-10">□ {{ $t('기본정보') }}</div>
      </div>

      <table class="table-approval-field mt-auto">
        <colgroup>
          <col width="38" />
          <col width="112" />
          <col width="112" />
          <col width="112" />
          <col width="112" />
        </colgroup>
        <tr>
          <th rowspan="2" class="gray p-0">
            <div class="flex justify-center items-center">
              <p style="writing-mode: vertical-lr">{{ $i18n.locale === 'ko' ? $t('결&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;재') : $t('결재') }}</p>
            </div>
          </th>
          <th class="gray">{{ $t('작성자') }}</th>
          <th class="gray">{{ $t('검토자') }}</th>
          <th class="gray">{{ $t('회람자') }}</th>
          <th class="gray">{{ $t('승인자') }}</th>
        </tr>
        <tr>
          <td style="vertical-align: middle; height: 80px;">
            <div class="signature-container">
              <img v-if="form.sign1.sign" :src="form.sign1.sign" class="signature-image" />
              <p v-else-if="form.sign1.name" class="name-text">{{ form.sign1.name }}</p>
            </div>
          </td>
          <td style="vertical-align: middle; height: 80px;">
            <div class="signature-container">
              <img v-if="form.sign2.sign" :src="form.sign2.sign" class="signature-image" />
              <p v-else-if="form.sign2.name" class="name-text">{{ form.sign2.name }}</p>
            </div>
          </td>
          <td style="vertical-align: middle; height: 80px;">
            <div class="signature-container">
              <img v-if="form.sign3.sign" :src="form.sign3.sign" class="signature-image" />
              <p v-else-if="form.sign3.name" class="name-text">{{ form.sign3.name }}</p>
            </div>
          </td>
          <td style="vertical-align: middle; height: 80px;">
            <div class="signature-container">
              <img v-if="form.sign4.sign" :src="form.sign4.sign" class="signature-image" />
              <p v-else-if="form.sign4.name" class="name-text">{{ form.sign4.name }}</p>
            </div>
          </td>
        </tr>
      </table>
    </section>

    <!-- 2. 기본 정보 -->
    <section class="section-stdInfo mb-5">
      <table class="w-full">
        <colgroup>
          <col width="140" />
          <col />
          <col width="140" />
          <col />
        </colgroup>
        <tr>
          <th>{{ $t('회사명') }}</th>
          <td colspan="3">
            <div class="text-left px-2"> {{ form.stdInfo.field_name }} </div>
          </td>
        </tr>
        <tr>
          <th>{{ $t('작성자') }}</th>
          <td>
            <div class="px-2"> {{ form.stdInfo.writer_name }} </div>
          </td>
          <th>{{ $t('작성일') }}</th>
          <td>
            <div class="px-2"> {{ form.stdInfo.date }} </div>
          </td>
        </tr>
      </table>
    </section>

    <!-- 3. 사업장 정보 -->
    <section class="section-worksite mb-5">
      <div class="division-title">□ {{ $t('사업장 정보') }}</div>
      <table class="w-full">
        <colgroup>
          <col width="140" />
          <col />
          <col width="140" />
          <col />
        </colgroup>
        <tr>
          <th>{{ $t('작업내용') }}</th>
          <td>{{ form.inputB_1 }}</td>
          <th>{{ $t('조사일') }}</th>
          <td>{{ form.inputB_5 }}</td>
        </tr>
        <tr>
          <th>{{ $t('작업자') }}</th>
          <td>{{ form.inputB_4 }}</td>
          <th>{{ $t('재해형태') }}</th>
          <td>{{ $t(form.inputB_6) }}</td>
        </tr>
      </table>
    </section>

    <!-- 4. 청취조사 내용 -->
    <section class="section-interview mb-5">
      <div class="division-title">□ {{ $t('청취조사 내용') }}</div>
      <table class="w-full">
        <colgroup>
          <col width="140" />
          <col />
        </colgroup>
        <tr>
          <th>{{ $t('경험담 1') }}</th>
          <td class="text-left">{{ form.inputC_1 }}</td>
        </tr>
        <tr>
          <th>{{ $t('경험담 2') }}</th>
          <td class="text-left">{{ form.inputC_2 }}</td>
        </tr>
        <tr>
          <th>{{ $t('경험담 3') }}</th>
          <td class="text-left">{{ form.inputC_3 }}</td>
        </tr>
      </table>
    </section>

    <!-- 5. 상세 내용 -->
    <section class="section-detail mb-5">
      <div class="division-title">□ {{ $t('상세 내용 ※육하원칙(누가, 언제, 어디서, 무엇을, 어떻게, 왜)에 따라 작성') }}</div>
      <table class="w-full">
        <colgroup>
          <col width="140" />
          <col />
        </colgroup>
        <tr>
          <th>{{ $t('근로자 의견') }}</th>
          <td class="text-left">
            <div style="min-height: 80px;">{{ form.inputD_1 }}</div>
          </td>
        </tr>
        <tr>
          <th>{{ $t('수행자 의견') }}</th>
          <td class="text-left">
            <div style="min-height: 80px;">{{ form.inputD_2 }}</div>
          </td>
        </tr>
      </table>
    </section>

    <!-- 6. 사진대지 -->
    <section class="section-photo" v-if="form.photoList && form.photoList.length > 0">
      <div class="division-title">□ {{ $t('사진대지') }}</div>
      <div class="photo-grid">
        <div v-for="(photo, index) in form.photoList" :key="index" class="photo-item">
          <div class="photo-box">
            <img v-if="photo.path" :src="photo.path" class="grid-photo" />
          </div>
          <div class="photo-desc">{{ photo.input }}</div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Print",
  props: {
    isPrint: Boolean,
    board: Object,
    form: Object,
  }
};
</script>

<style lang="scss" scoped>
.print {
  .signature-container {
    width: 100%;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5px;

    .signature-image {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 70px;
      object-fit: contain;
      display: block;
    }
    .name-text {
      font-size: 16px;
      margin-top: 5px;
    }
  }

  table {
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;

    th, td {
      border: 1px solid #757575;
      text-align: center;
      font-size: 18px;
      padding: 10px;
    }
    th {
      background-color: #ececec;
      font-weight: 500;
    }
    td {
      word-break: break-all;
    }
    .gray {
      background-color: #ececec;
    }
    .text-left {
      text-align: left;
      padding: 10px 14px;
      word-break: break-word;
    }
  }

  .section-approval {
    display: grid;
    grid-template-columns: 1fr auto;
    width: 100%;
    align-items: flex-start;

    .header-left-area {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      padding-top: 20px;

      .print-title {
        font-size: 32px;
        font-weight: bold;
        color: #000;
        text-align: center;
        margin-bottom: 20px;
      }
    }

    .table-approval-field {
      width: auto;
      margin-left: 10px;
      tr:last-child { th, td { border-bottom: 1px solid #757575; } }
    }
  }

  .division-title {
    font-size: 24px;
    font-weight: bold;
    color: #3C3C3C;
    padding: 1.25rem 0rem;
  }

  .photo-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    width: 100%;
  }
  .photo-item {
    border: 1px solid #757575;
    display: flex;
    flex-direction: column;
  }
  .photo-box {
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #757575;
    padding: 10px;
    background: #f9f9f9;

    .grid-photo {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }
  .photo-desc {
    padding: 10px;
    font-size: 16px;
    min-height: 50px;
    text-align: left;
    background: #fff;
  }
}

@media print {
  section {
    page-break-inside: avoid;
    page-break-after: auto;
  }
  tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }
  .photo-item {
    page-break-inside: avoid;
  }
}
</style>
